import { render, staticRenderFns } from "./bars.vue?vue&type=template&id=387d0512&scoped=true"
import script from "./bars.vue?vue&type=script&lang=js"
export * from "./bars.vue?vue&type=script&lang=js"
import style0 from "./bars.vue?vue&type=style&index=0&id=387d0512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387d0512",
  null
  
)

export default component.exports